import { FC, Fragment } from 'react';
import cn from 'classnames';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { useAppRouter } from '@/shared/hooks/app/useAppRouter';
import { Icon } from '@/shared/uikit/Icon';
import { Text } from '@/shared/uikit/Text';

export type BreadcrumbItem = {
  title: string;
  href?: string;
};

type BreadcrumbProps = {
  items: BreadcrumbItem[];
};

export const Breadcrumb: FC<BreadcrumbProps> = ({ items }) => {
  const router = useAppRouter();

  return (
    <BreadcrumbsContainer>
      {items.map((item, index) => (
        <Fragment key={index}>
          {index !== 0 && (
            <Icon size="s16" name="caret-right" style={{ color: COLORS.systemDark200 }} />
          )}
          <StyledText
            onClick={() => item.href && router.pushShallowGuarded(item.href)}
            className={cn({ lastItem: index === items.length - 1, link: Boolean(item.href) })}
          >
            {item.title}
          </StyledText>
        </Fragment>
      ))}
    </BreadcrumbsContainer>
  );
};

const BreadcrumbsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const StyledText = styled(Text)`
  &&& {
    color: ${COLORS.systemDark200};

    &.lastItem {
      color: ${COLORS.systemDark300};
    }

    &.link {
      cursor: pointer;
    }
  }
`;
